export function getActivityUrl(activityUrl: string | undefined): string | null {
  if (!activityUrl) {
    return null;
  }

  let urlToCheck = activityUrl;
  if (activityUrl.startsWith('www.')) {
    urlToCheck = 'https://' + activityUrl;
  }

  try {
    const url = new URL(urlToCheck);
    if (url.host) {
      return url.toString();
    }
  } catch {
    // ignore
  }

  const angularAuxiliaryPathPattern = /\([a-zA-Z0-9]+:[a-zA-Z0-9/-]+\)/;
  if (angularAuxiliaryPathPattern.test(activityUrl)) {
    const currentUrl = window.location.protocol + '//' + window.location.host + window.location.pathname;
    return currentUrl + activityUrl;
  }

  const host = window.location.protocol + '//' + window.location.host;
  return host + activityUrl;
}
